import { create } from "zustand";
import { PartyState } from "@/app/store";
export interface PartyStore {
	readonly partyState: PartyState;
	setPartyState: (partyState: PartyState) => void;
	getPartyState: () => PartyState;
}

export const usePartyStore = create<PartyStore>((set, get) => {
	return {
		partyState: {
			status: "not-connected"
		},

		setPartyState: (partyState: PartyState): void => {
			set({ partyState });
		},

		getPartyState: (): PartyState => {
			return get().partyState;
		}
	};
});
